var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bigBox"},[_c('h3',[_vm._v(_vm._s(_vm.name))]),_c('img',{attrs:{"src":"https://kz-images.oss-cn-shenzhen.aliyuncs.com/kzweb/Mobile/abuout/serve.png","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }